import React, { useState, useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import MainLogo from "../assets/images/AstraLogo.svg";

const allSteps = [
  { path: "/q1", label: "Priority" },
  { path: "/q2", label: "Your Goals" },
  { path: "/q3", label: "Planning Support" },
  { path: "/q4", label: "Big Decisions" },
  { path: "/q5", label: "Debts" },
  { path: "/q6", label: "Investments" },
  { path: "/q7", label: "About You" },
];

const OnboardingSidebar = () => {
  const [currentStep, setCurrentStep] = useState("");
  const location = useLocation();

  const steps = useMemo(() => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
    if (currentUser.user?.quickSetup === true) {
      return [
        { path: "/q1", label: "Priority" },
        { path: "/q7", label: "About You" },
      ];
    }
    return allSteps;
  }, []);

  useEffect(() => {
    // Determine the current step based on the URL
    const path = location.pathname;
    const step = steps.find((step) => step.path === path);
    if (step) {
      setCurrentStep(step.label);
    } else {
      setCurrentStep("");
    }
  }, [location]);

  return (
    <div className="onboarding-sidebar">
      <div className="text-center">
        <Link className="logo" to="/dashboard">
          <img src={MainLogo} alt="Main Logo" />
        </Link>
      </div>
      <div className="onbording-info">
        <h5>Let’s get to know your goals.</h5>
        <p>
          Answer a few quick questions to help your advisor understand what matters most to you.
          Share whatever you can - skip anything you’re unsure about.<br></br>
          Your advisor will help fill in the rest.
        </p>
        <svg width="177" height="2" viewBox="0 0 177 2" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.75 1H176.25" stroke="#9B9B9B" strokeLinecap="round" />
        </svg>

      </div>
      <div className="onbording-stepper">
        <ul>
          {steps.map((step, index) => (
            <li
              key={step.path}
              className={
                currentStep === step.label
                  ? "current"
                  : index < steps.findIndex((s) => s.label === currentStep) && "completed"
              }
            >
              {step.label}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default OnboardingSidebar;
